export class SpecificationResult {
    public readonly isSatisfied: boolean;
    public readonly errorReason?: string;
    
    constructor(isSatisfied: boolean, errorReason: string = "") {
        this.isSatisfied = isSatisfied;
        this.errorReason = errorReason;
    }
}